<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <Caption label="Mobile App" />
        <ul>
          <li>
            <SectionTechItem 
              :image="'tech_icon_github.png'"
              :record ="{
                text1:'Github & CI',
                text2:'서버, 앱, 백앤드 관리자, 배치까지 모든 형상은 배포 자동화되어 있습니다. 지속적으로 고객에게 개발 산출물을 확인할 수 있습니다.',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_devil.png'"
              :record ="{
                text1:'Devil App Builder',
                text2:'네이티브 앱을 빠르고 쉽게 개발할 수 있는 플랫폼입니다.',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_android.png'"
              :record ="{
                text1:'Java & Andorid Studio',
                text2:'모든 화면은 Native이며, Java로 개발됩니다.',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_ios.png'"
              :record ="{
                text1:'Objective-C & Xcode',
                text2:'모든 화면은 Native이며, Objective-C로 개발됩니다.',
              }"/>
          </li>
        </ul>

        <div class="desc">
          높은 퀄리티의 네이티브 화면을 만듭니다. 또한 하이브리드의 강점인 단점인 원격 배포(Code Push)도 지원합니다.  앱 배포 없이 앱의 기능이 갱신되는 Devil App Builder 플랫폼을 사용하여 앱을 개발하고 있습니다
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionTechItem from "./SectionTechItem.vue";
export default {
  components: {
    Caption,
    SectionTechItem,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 100px 20px 100px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.desc {
  font-weight: 300;
  font-size: 24px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 100px 20px 100px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  